






























































import Vue from 'vue';
import Component from 'vue-class-component';
import EventApi from "../../api/EventsApi";
import PixiPainter from "../../libs/table-hand/api/render/PixiPainter";
import {ICardInfo} from "../../libs/table-hand/api/render/PixiPainter";
// @ts-ignore
import store from "../../store";
import {Player, PlayerColor} from '../../../types';

const NOIR = '#010101';
enum Tool { Select, Brush, Text, Eraser, Trash }

@Component({
    components: {

    }
})

export default class GameHand extends Vue {
    private zoomedImages: Array<string> = [];
    private maxWidth: string = '';
    private maxHeight: string = '';
    private pixiPainter: PixiPainter | null = null;
    private editMode: boolean = false;
    private card: ICardInfo | null = null;

    private readonly tools = [
        { id: Tool.Select, path: "M12.6383 8.35043C11.5646 7.50798 10 8.27976 10 9.65186V28.3479C10 29.9112 11.9556 30.5969 12.9169 29.3706L17.4841 23.5446C17.8252 23.1096 18.3448 22.8559 18.8946 22.8559H26.3621C27.9185 22.8559 28.5943 20.8695 27.3658 19.9056L12.6383 8.35043Z" },
        { id: Tool.Brush,  path: "M6.00587 7.17913C6.07437 6.46429 6.72425 5.93894 7.45741 6.00572L12.4527 6.46077C15.9936 6.80319 19.3894 7.21575 22.1806 7.68447C24.9029 8.1416 27.2442 8.68066 28.53 9.34224C28.8621 9.51309 29.2254 9.74161 29.5072 10.0553C29.8063 10.3882 30.091 10.9164 29.9725 11.5704C29.8644 12.1663 29.4701 12.5677 29.1559 12.8088C28.8267 13.0614 28.4204 13.266 27.9878 13.4408C26.2958 14.1243 23.107 14.77 18.1323 15.4045C15.8889 15.6906 14.2351 15.97 13.0639 16.2314C13.3453 16.2912 13.6484 16.3501 13.9717 16.408C15.5933 16.6984 17.638 16.9474 19.8131 17.1371C21.4753 17.2821 23.2563 17.512 24.7772 17.8052C25.5367 17.9516 26.2509 18.1175 26.8621 18.3027C27.4449 18.4793 28.0413 18.7045 28.49 19.0076C28.7118 19.1575 29.0066 19.398 29.2007 19.7605C29.4281 20.1852 29.4715 20.7007 29.2485 21.1879C29.0587 21.6027 28.7323 21.8721 28.4788 22.0392C28.2098 22.2166 27.8958 22.3613 27.5665 22.4851C26.2878 22.9655 24.0142 23.4033 20.5029 23.812C17.0212 24.2172 14.9312 24.7306 13.7884 25.2363C13.3317 25.4383 13.1035 25.6062 12.9995 25.7045C13.0408 25.7643 13.1141 25.8547 13.2416 25.9737C13.4814 26.1977 13.833 26.4485 14.2897 26.7116C15.1986 27.2353 16.374 27.7228 17.5123 28.1028L21.8382 29.4624C22.539 29.6826 22.924 30.4152 22.6981 31.0985C22.4722 31.7818 21.7209 32.1572 21.0201 31.937L16.6718 30.5704L16.6607 30.5667C15.4169 30.1521 14.0543 29.596 12.9331 28.95C12.3733 28.6274 11.8357 28.261 11.3972 27.8514C10.9725 27.4548 10.5442 26.9287 10.3693 26.2732C10.1739 25.5405 10.3384 24.8067 10.8225 24.1884C11.2614 23.6276 11.924 23.2061 12.6863 22.8687C14.2163 22.1917 16.6423 21.6429 20.1868 21.2304C22.3039 20.9839 23.8612 20.7367 24.9692 20.5024C24.7448 20.4525 24.5079 20.4035 24.26 20.3557C22.8529 20.0845 21.1684 19.8657 19.5754 19.7267C17.3533 19.5329 15.2206 19.2751 13.49 18.9652C12.6259 18.8104 11.8407 18.6389 11.185 18.4494C10.5636 18.2697 9.93342 18.0399 9.47148 17.7203C9.24291 17.5622 8.92449 17.294 8.74332 16.8776C8.52699 16.3804 8.5832 15.8509 8.842 15.4163C9.06049 15.0493 9.38511 14.8087 9.64288 14.6532C9.91818 14.4871 10.2393 14.3462 10.5831 14.2217C11.9237 13.7365 14.2613 13.2761 17.7865 12.8265C22.0961 12.2769 24.813 11.744 26.3288 11.265C25.2932 10.9315 23.7311 10.5831 21.728 10.2467C19.0242 9.79266 15.6988 9.38748 12.1933 9.04842L7.20935 8.59441C6.47619 8.52762 5.93737 7.89398 6.00587 7.17913Z" },
        { id: Tool.Text,   path: "M9.09524 7C7.93807 7 7 7.89543 7 9V12C7 13.1046 7.93807 14 9.09524 14C10.2524 14 11.1905 13.1046 11.1905 12V11H15.9048V27H13.2857C12.1285 27 11.1905 27.8954 11.1905 29C11.1905 30.1046 12.1285 31 13.2857 31H22.7143C23.8715 31 24.8095 30.1046 24.8095 29C24.8095 27.8954 23.8715 27 22.7143 27H20.0952V11H24.8095V12C24.8095 13.1046 25.7476 14 26.9048 14C28.0619 14 29 13.1046 29 12V9C29 7.89543 28.0619 7 26.9048 7H9.09524Z" },
        { id: Tool.Eraser, path: "M23.3558 5.81228L30.1921 12.6716C31.2693 13.7685 31.2693 15.518 30.1921 16.615L17.5 29.3754C15.3455 31.5415 11.8514 31.5415 9.68312 29.3754L4.80793 24.474C3.73069 23.377 3.73069 21.6275 4.80793 20.5306L19.4473 5.81228C20.5384 4.72924 22.2785 4.72924 23.3558 5.81228ZM6.75524 22.5023L11.6442 27.4037C12.7215 28.5007 14.4616 28.5007 15.5527 27.4037L20.4279 22.5023L13.5916 15.6291L6.75524 22.5023Z" },
        { id: Tool.Trash,  path: "M18 5.0625C20.5313 5.0625 22.594 7.06893 22.6844 9.57815L22.6875 9.75075L27.75 9.75C28.4749 9.75 29.0625 10.3376 29.0625 11.0625C29.0625 11.7511 28.5322 12.3159 27.8576 12.3706L27.75 12.375H26.8748L25.6544 28.5524C25.5289 30.215 24.1433 31.5 22.4759 31.5H13.5241C11.8567 31.5 10.4711 30.215 10.3456 28.5524L9.1245 12.375H8.25C7.56137 12.375 6.99661 11.8447 6.94185 11.1701L6.9375 11.0625C6.9375 10.3739 7.46783 9.80911 8.14235 9.75435L8.25 9.75H13.3125C13.3125 7.27622 15.2288 5.25002 17.6579 5.0748L17.8282 5.06559L18 5.0625ZM20.8125 14.8125C20.3271 14.8125 19.9278 15.1814 19.8798 15.6541L19.875 15.75V24.75L19.8798 24.8459C19.9278 25.3186 20.3271 25.6875 20.8125 25.6875C21.2979 25.6875 21.6972 25.3186 21.7452 24.8459L21.75 24.75V15.75L21.7452 15.6541C21.6972 15.1814 21.2979 14.8125 20.8125 14.8125ZM15.1875 14.8125C14.7021 14.8125 14.3029 15.1814 14.2548 15.6541L14.25 15.75V24.75L14.2548 24.8459C14.3029 25.3186 14.7021 25.6875 15.1875 25.6875C15.6729 25.6875 16.0722 25.3186 16.1202 24.8459L16.125 24.75V15.75L16.1202 15.6541C16.0722 15.1814 15.6729 14.8125 15.1875 14.8125ZM18.1256 7.69126L18 7.6875C16.9031 7.6875 16.0062 8.54378 15.9413 9.62436L15.9375 9.75075L20.0625 9.75C20.0625 8.6531 19.2062 7.7562 18.1256 7.69126Z" },
    ];
    private curTool = Tool.Brush;
    private startToolId = -1;
    private mainToolbarVisible = false;
    private isSmallWindowSize  = false;

    private readonly sizes = [
        { id: 0, r: "4.5" },
        { id: 1, r: "6.5" },
        { id: 2, r: "8.5" },
    ];
    private curSize = 1;
    private sizeToolbarVisible  = false;

    private readonly fonts = [
        { id: 0, path: "M5.7619 5C5.34112 5 5 5.33579 5 5.75V6.875C5 7.28921 5.34112 7.625 5.7619 7.625C6.18269 7.625 6.52381 7.28921 6.52381 6.875V6.5H8.2381V12.5H7.28571C6.86493 12.5 6.52381 12.8358 6.52381 13.25C6.52381 13.6642 6.86493 14 7.28571 14H10.7143C11.1351 14 11.4762 13.6642 11.4762 13.25C11.4762 12.8358 11.1351 12.5 10.7143 12.5H9.76191V6.5H11.4762V6.875C11.4762 7.28921 11.8173 7.625 12.2381 7.625C12.6589 7.625 13 7.28921 13 6.875V5.75C13 5.33579 12.6589 5 12.2381 5H5.7619Z" },
        { id: 1, path: "M4.14286 3C3.51167 3 3 3.48502 3 4.08333V5.70833C3 6.30664 3.51167 6.79167 4.14286 6.79167C4.77404 6.79167 5.28571 6.30664 5.28571 5.70833V5.16667H7.85714V13.8333H6.42857C5.79739 13.8333 5.28571 14.3184 5.28571 14.9167C5.28571 15.515 5.79739 16 6.42857 16H11.5714C12.2026 16 12.7143 15.515 12.7143 14.9167C12.7143 14.3184 12.2026 13.8333 11.5714 13.8333H10.1429V5.16667H12.7143V5.70833C12.7143 6.30664 13.226 6.79167 13.8571 6.79167C14.4883 6.79167 15 6.30664 15 5.70833V4.08333C15 3.48502 14.4883 3 13.8571 3H4.14286Z" },
        { id: 2, path: "M2.52381 1C1.68223 1 1 1.63426 1 2.41667V4.54167C1 5.32407 1.68223 5.95833 2.52381 5.95833C3.36539 5.95833 4.04762 5.32407 4.04762 4.54167V3.83333H7.47619V15.1667H5.57143C4.72985 15.1667 4.04762 15.8009 4.04762 16.5833C4.04762 17.3657 4.72985 18 5.57143 18H12.4286C13.2701 18 13.9524 17.3657 13.9524 16.5833C13.9524 15.8009 13.2701 15.1667 12.4286 15.1667H10.5238V3.83333H13.9524V4.54167C13.9524 5.32407 14.6346 5.95833 15.4762 5.95833C16.3178 5.95833 17 5.32407 17 4.54167V2.41667C17 1.63426 16.3178 1 15.4762 1H2.52381Z" },
    ];
    private curFont = 1;
    private fontToolbarVisible  = false;

    private readonly colors = [
        { id: 0, color: NOIR },
    ];
    private curColor = 1;
    private colorToolbarVisible = false;

    mounted(): void
    {
        this.bindEvents();
    }

    beforeDestroy(): void
    {

    }

    private onImgLoad(): void
    {
        const image = this.$refs.image as HTMLImageElement;
        const imgNaturalWidth = this.card?.cardSize.width ?? image.naturalWidth,
            imgNaturalHeight = this.card?.cardSize.height ?? image.naturalHeight;
        this.maxWidth  = imgNaturalWidth  * 3 + 'px';
        this.maxHeight = imgNaturalHeight * 3 + 'px';
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoom'});

        const paintContainer = this.$refs.paintContainer as HTMLElement;
        if (paintContainer) {
            this.pixiPainter = PixiPainter.getInstance(image);
            const paint = this.pixiPainter.paint;
            if (paint) {
                this.colorBtnHandler(this.curColor);
                paint.loadImage(image, this.card);
            }
            paintContainer.prepend(this.pixiPainter.view);
        }

        if (this.startToolId < 0) {
            enum tool { cursor, brush, text };
            const defaultTool = store.getters.getGameState?.tasks?.state?.activity?.settings?.painterDefaultTool ?? 'cursor';
            this.startToolId = tool[defaultTool as keyof typeof tool] ?? 0;
        }
        this.btnHandler(this.startToolId);
    }

    private get isOldScene(): boolean
    {
        let params = new URLSearchParams(document.location.search);
        return !!params.get('oldScene');
    }

    private get imagesForZoom(): Array<string>
    {
        return this.zoomedImages;
    }

    private closeZoom(): void
    {
        if (store.getters.getPainterEditMode) {
            return;
        }
        this.zoomedImages = [];
    }

    /**
     * Обработка нажатия пробела
     * @param e
     * @private
     */
    private pressSpaceEvent(e: any): void
    {
        const keySpaceCode = 'Space';
        if (e.code === keySpaceCode) {
            this.closeZoom();
        }
    }

    private bindEvents(): void
    {
        EventApi.addEventListener(EventApi.ZOOM_ITEMS, (e: any) => {
            this.zoomedImages = [];
            (e.detail as Array<string>).forEach((img) => {
                this.zoomedImages.push(img);
            });
        });

        EventApi.addEventListener(EventApi.EDIT_START, (e: any) => {
            this.card = e.detail;
            const playerColor = e.detail.playerColorCode;
            let colorCodes:Array<string> = [playerColor];
            const players = Array.from(store.getters.getPlayers ?? []);
            players.forEach(player => {
                const code = (player as Player).color.code;
                if (code !== playerColor) {
                    colorCodes.push(code);
                }
            });
            const availableColors = Array.from(store.getters.getGameState?.availableColors ?? []);
            availableColors.forEach(color => colorCodes.push((color as PlayerColor).code));
            colorCodes.forEach((code, i) => {
                this.colors[i + 1] = { id: i + 1, color: code };
            });
        });

        EventApi.addEventListener(EventApi.EDIT_MODE_ON, (e: any) => {
            this.editMode = true;
        });

        EventApi.addEventListener(EventApi.EDIT_MODE_OFF, (e: any) => {
            this.closeZoom();
            this.editMode = false;
            this.mainToolbarVisible = false;
            this.card = null;
        });

        EventApi.addEventListener(EventApi.EDIT_MODE_KEY, (e: any) => {
            this.editMode = true;
            this.mainToolbarVisible = true;
        });

        EventApi.addEventListener(EventApi.EDIT_SMALL_SIZE, (e: any) => {
            this.isSmallWindowSize = e.detail.isSmallWindowSize;
        });

        document.addEventListener('keyup', this.pressSpaceEvent.bind(this));
    }

    /**
     * btn click handler
     */
    private btnHandler(btnId: number) {
        this.pixiPainter?.paint?.btnHandler(btnId);
        if (Tool.Trash === btnId) {
            setTimeout(() => this.btnHandler(Tool.Brush), 128);
        }
        this.curTool = btnId;
        this.startToolId = btnId;
        this.colorToolbarVisible = this.curTool === btnId && (Tool.Brush === btnId || Tool.Text   === btnId);
        this.sizeToolbarVisible  = this.curTool === btnId && (Tool.Brush === btnId || Tool.Eraser === btnId);
        this.fontToolbarVisible  = this.curTool === btnId && (Tool.Text === btnId);
    }

    /**
     * Скрыть субменю
     */
    private hideToolbars() {
        this.colorToolbarVisible = false;
        this.sizeToolbarVisible  = false;
        this.fontToolbarVisible  = false;
    }

    /**
     * color btn click handler
     */
    private colorBtnHandler(btnId: number) {
        this.curColor = btnId;
        this.pixiPainter?.paint?.colorBtnHandler(btnId, this.colors[btnId].color);
        this.hideToolbars();
    }

    /**
     * size btn click handler
     */
    private sizeBtnHandler(btnId: number) {
        this.curSize = btnId;
        this.pixiPainter?.paint?.sizeBtnHandler(btnId, this.curTool);
        this.hideToolbars();
    }

    /**
     * font btn click handler
     */
    private fontBtnHandler(btnId: number) {
        this.curFont = btnId;
        this.pixiPainter?.paint?.fontBtnHandler(btnId, this.curTool);
        this.hideToolbars();
    }

    private hasCorner(id: number) {
        return [Tool.Brush, Tool.Text, Tool.Eraser].includes(id);
    }

}
